<template>
  <div class="renwu">
    <!-- 团体预约统计 -->
    <div class="top">
      <Select class="select" @on-change="getSelect" clearable>
        <Option v-for="(item, index) in typeList" :value="item.timeInterva + ''" :key="index">{{ item.timeInterva }}</Option>
      </Select>

      <Date-picker @on-change="datePicker" :options="options" class="data" type="daterange" placeholder="选择日期"></Date-picker>
      <Button class="btn fourSize" type="success" ghost @click="daochu">导出</Button>
    </div>
    <div class="table-cont">
      <Table @on-selection-change="selectChange" @on-sort-change="changesort" stripe :columns="columns" :data="data"></Table>
    </div>
    <div class="page-div">
      <Page :total="obj.total" @on-page-size-change="changepeoplepage" @on-change="changePeoplecurrent" show-elevator show-total :current="current" :page-size="pageSize" show-sizer class="page-div-page" />
    </div>
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success">操作成功</Alert>
    <Alert class="alertTitle" v-show="alertTitleIshow2" type="error" show-icon>{{ alertTitle }}</Alert>

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->

    <!--  -->
    <Modal class="ivumodal" footer-hide width="850" v-model="seeShow" title="预约清单">
      <Yuallsee ref="Allsee"></Yuallsee>
    </Modal>
  </div>
</template>
<script>
import {
  selectBookingTime,
  selectOrgReservationListForPage,
} from "../servers/api";
import Yuallsee from "../tan/yuallsee";
export default {
  name: "renwu",
  data() {
    return {
      isiconfontshow: false,
      alertTitleIshow: false,
      alertTitleIshow2: false,
      alertTitle: "",
      typeList: [
        {
          name: "预约日期",
        },
        {
          name: "团检加项",
        },
        {
          name: "个检加项",
        },
      ], //select选择筛选
      data: [],
      background: "#fff",
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "预约日期",
          width: 170,
          align: "center",
          key: "reservationTime",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "预约时段",
          width: 160,
          align: "center",
          key: "appointmentTime",
          ellipsis: true,
          sortable: true,
          render: (h, params) => {
            let a = params.row.appointmentTime;
            let num = "";
            if (a) {
              num = a.slice(0, 10);
            } else {
              num = "全部";
            }

            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  color: "#7F7F7F",
                },
              },
              num
            );
          },
        },
        {
          title: "团体名称",
          width: 300,
          align: "center",
          key: "orgName",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "任务ID",
          align: "center",
          width: 120,
          ellipsis: true,
          sortable: true,
          key: "idOrgReservation",
        },
        {
          title: "任务开始日期",
          align: "center",
          width: 180,
          ellipsis: true,
          sortable: true,
          key: "dateReservation",
          render: (h, params) => {
            let a = params.row.dateReservation;
            let num = "";
            if (a) {
              num = a.slice(0, 10);
            }

            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  color: "#7F7F7F",
                },
              },
              num
            );
          },
        },
        {
          title: "体检人数",
          align: "center",
          width: 150,
          ellipsis: true,
          sortable: true,
          key: "peCount",
        },
        {
          title: "预约人数",
          width: 130,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "bookedPeopleNum",
        },
        {
          title: "操作",
          key: "awssd",
          align: "center",
          width: 120,
          fixed: "right",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  // width:'50px',
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  background: this.background,
                  border: "1px solid #53CAC3",
                  "border-radius": "5px",
                  width: "65px",
                  "margin-left": "12px",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    //    console.log(params.row)
                    this.chengeTable(params.row);
                  },
                },
              },
              "查看"
            );
          },
        },
      ],
      current: 1,
      pageSize: 20,
      options: {
        shortcuts: [
          {
            text: "最近一周",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: "最近一个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: "最近三个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
      seeShow: false,
      medicalType: "",
      orderField: 1,
      isAsc: "",
      obj: {},
      startDate: "",
      endDate: "",
      appointmentTime: "",
      selectNum: 0,
      selectList: [],
    };
  },

  methods: {
    selectChange(item) {
      //表格select选中
      this.selectList = item;
      this.selectNum = this.selectList.length;
    },
    daochu() {
      //导出
      let baseUrl = sessionStorage.getItem("baseUrl");
      let token = JSON.parse(sessionStorage.getItem("login")).token || "";
      if (this.selectNum == 0) {
        let url =
          "/pms/statistical/exportOrgReservationDetails?" +
          "&startDate=" +
          this.startDate +
          "&endDate=" +
          this.endDate +
          "&pageNum=" +
          this.current +
          "&pageSize=" +
          this.pageSize;
        url = baseUrl + url;
        url += url.indexOf("?") === -1 ? "?1=1" : "";
        window.open(url + "&token=" + token);
        return;
      } else {
        let list = [];
        for (let i = 0; i < this.selectList.length; i++) {
          list.push(this.selectList[i].idOrgReservation);
        }
        window.location.href =
          baseUrl +
          "/pms/statistical/exportOrgReservationDetails?startDate=" +
          this.startDate +
          "&endDate=" +
          this.endDate +
          "&token=" +
          token +
          "&appointmentTime" +
          this.appointmentTime +
          "&idOrgReservations=" +
          list.join(",");
      }
    },
    getselectBookingTime() {
      //获取预约时间段
      selectBookingTime({}).then((res) => {
        if (res.data.code == 1) {
          this.typeList = res.data.data || [];
        }
      });
    },
    datePicker(data) {
      //预约时间搜索
      this.startDate = data[0];
      this.endDate = data[1];
      this.orderField = "";
      this.isAsc = "";
      this.medicalType = "";
      this.selectAllFeeItemInfoList(1);
    },
    selectAllFeeItemInfoList(index, num) {
      //列表
      this.isiconfontshow = true;
      if (index) {
        this.current = 1;
      }
      if (num) {
        this.startDate = "";
        this.endDate = "";
        this.orderField = "";
        this.isAsc = "";
        this.medicalType = "1";
      }
      let params = {
        pageNum: this.current,
        pageSize: this.pageSize,
        startDate: this.startDate,
        endDate: this.endDate,
        appointmentTime: this.appointmentTime,
        orderField: this.orderField,
        isAsc: this.isAsc,
      };
      this.selectChange([]);
      selectOrgReservationListForPage(params).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          this.obj = res.data.data;
          this.data = res.data.data.list || [];
        }
      });
    },
    chengeTable(item) {
      //点击查看 传递子组件参数
      let onj = item;
      item.startDate = this.startDate;
      item.endDate = this.endDate;
      this.$refs.Allsee.postItem(item);
      this.seeShow = true;
    },
    changePeoplecurrent(num) {
      //换页
      this.current = num;
      this.selectAllFeeItemInfoList();
    },
    changepeoplepage(num) {
      //换每页请求多少条
      this.pageSize = num;
      this.selectAllFeeItemInfoList(1);
    },
    getSelect(name) {
      //任务创建时间select
      this.appointmentTime = name;
      this.selectAllFeeItemInfoList(1);
    },
    changesort(item) {
      //排序
      this.orderField = item.key;
      this.isAsc = item.order;
      this.current = 1;
      if (item.order == "normal") {
        this.isAsc = "";
        this.orderField = "";
      }
      this.selectAllFeeItemInfoList(1);
    },
    clear() {
      this.seeShow = false;
    },
  },
  created() {
    this.selectAllFeeItemInfoList();
    this.getselectBookingTime();
  },
  components: {
    Yuallsee,
  },
};
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.renwu {
  font-size: 13px;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
  .top {
    width: calc(100% - 250px);
    height: 60px;
    line-height: 35px;
    position: fixed;
    top: 111px;
    z-index: 99;
    background: #fff;
    padding-top: 17px;
    left: 220px;
    padding-left: 15px;
    padding-bottom: 15px;
  }
  .btn {
    float: right;
  }
  .select {
    width: 130px;
    margin-right: 10px;
  }
  .journal-input {
    width: 250px;
    vertical-align: top;
  }
  .data {
    width: 250px;
    vertical-align: top;
  }
  .table-cont {
    padding-top: 15px;
    margin: 40px 0 60px;
  }
  .page-div {
    width: 100%;
    margin-top: 15px;
    position: fixed;
    background: #fff;
    width: calc(100% - 270px);
    height: 60px;
    z-index: 99;
    bottom: 0;
    padding-top: 15px;
    .page-div-left {
      float: left;
    }
    .page-div-page {
      float: right;
      margin-right: 15px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/xinxi/tuanti.vue